<div>
    <h1>Unauthorized</h1>
    <br />
    <p>You are not authorized to see the page that you are trying to access.</p>
    <br />
    <p>Do you think this is an error? <a href="">Get in touch.</a></p>
</div>
